import './skill-card.scss';
import DotnetCoreIcon from '../../Assets/DotnetCore.svg';
import AzureFunctionsIcon from '../../Assets/FunctionApps.svg';
import AzureDevopsIcon from '../../Assets/AzureDevops.svg';
import AzureIcon from '../../Assets/Azure.svg';
import HTMLIcon from '../../Assets/HTML.svg';
import CSSIcon from '../../Assets/CSS.svg';
import SASSIcon from '../../Assets/SASS.svg';
import AngularIcon from '../../Assets/Angular.svg';
import GitIcon from '../../Assets/Git.svg';
import RestApisIcon from '../../Assets/RestApis.svg';
import ReactJSIcon from '../../Assets/ReactJS.svg';
import VueJSIcon from '../../Assets/VueJS.png';
import CSharpIcon from '../../Assets/CSharp.svg';
import MySQLIcon from '../../Assets/MySQL.svg';

function SkillCard({ name }: { name: string }) {
	const skillIcons: any = {
		'dotnet core': DotnetCoreIcon,
		azure: AzureIcon,
		'azure devops': AzureDevopsIcon,
		'azure functions': AzureFunctionsIcon,
		html: HTMLIcon,
		css: CSSIcon,
		sass: SASSIcon,
		angular: AngularIcon,
		git: GitIcon,
		'rest apis': RestApisIcon,
		'reactjs': ReactJSIcon,
		'vuejs': VueJSIcon,
		'csharp': CSharpIcon,
		'mysql': MySQLIcon
	};

	return (
		<div className="SkillCardContainer">
			<div className="SkillCardImage">
				<img
					className="SkillCard"
					src={skillIcons[name]}
					alt={`${name} logo`}
				/>
			</div>
			<div>
				<span>{name.toUpperCase()}</span>
			</div>
		</div>
	);
}

export default SkillCard;
